/*
 * Copyright © Manatee. 2026 All Rights Reserved.
 * Proprietary and confidential.
 */

import { AccountsDirectory } from "./AccountsDirectory";
import { INTERNAL_ROLES } from "../api/accounts";
import { useChrome } from "../contexts/ChromeContext";

export function Access() {
  useChrome({}, []);
  return (
    <div className="space-y-8">
      <header className="enter">
        <h1 className="font-display text-2xl leading-tight text-text-primary sm:text-[1.75rem]">
          Access
        </h1>
        <p className="mt-2 text-[15px] leading-relaxed text-text-secondary">
          Care team and staff accounts. Every action here requires the Admin role.
        </p>
      </header>
      <AccountsDirectory
        scope="internal"
        roleOptions={[...INTERNAL_ROLES]}
        searchPlaceholder="Search staff by name, email, phone, or id"
      />
    </div>
  );
}
